import { Modal } from "antd";
import QRCode from "react-qr-code";

// Encode invoice number to Base64 token
function encodeReceiptToken(invoiceNo) {
  try {
    const payload = JSON.stringify({
      invoice: invoiceNo,
      timestamp: Date.now()
    });
    const encoded = btoa(payload)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
    return encoded;
  } catch (error) {
    console.error('Error encoding receipt token:', error);
    return null;
  }
}

export default function QRReceiptModal({
  isModalOpen,
  invoiceNumber,
  onNoReceiptButtonClicked,
  setIsModalOpen,
}) {
  const token = encodeReceiptToken(invoiceNumber);
  const receiptUrl = `${window.location.origin}/Receipt?id=${token}`;

  const handleClose = () => {
    if (onNoReceiptButtonClicked) onNoReceiptButtonClicked();
    else if (setIsModalOpen) setIsModalOpen(false);
  };

  return (
    <Modal open={isModalOpen} onCancel={handleClose} footer={null} centered>
      <div style={{ margin: "50px", textAlign: "center" }}>
        <QRCode value={receiptUrl} />
      </div>
    </Modal>
  );
}
